import { useEffect, useRef } from "react";

// Small custom hook that keeps a bounded undo stack.
// snapshotFn returns the current state to remember.
// applyFn accepts a snapshot and restores it.
export function useUndoManager({ maxDepth = 40 } = {}) {
  const stackRef = useRef([]);

  const push = (snapshot) => {
    stackRef.current.push(snapshot);
    if (stackRef.current.length > maxDepth) stackRef.current.shift();
  };

  const pop = () => {
    if (stackRef.current.length === 0) return null;
    return stackRef.current.pop();
  };

  const size = () => stackRef.current.length;
  const clear = () => {
    stackRef.current = [];
  };

  return { push, pop, size, clear };
}

// Global Ctrl+Z / Cmd+Z listener that calls onUndo.
export function useKeyboardUndo(onUndo) {
  useEffect(() => {
    const handler = (e) => {
      const isMac = navigator.platform.toUpperCase().includes("MAC");
      const meta = isMac ? e.metaKey : e.ctrlKey;
      if (meta && !e.shiftKey && e.key.toLowerCase() === "z") {
        e.preventDefault();
        onUndo();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onUndo]);
}
